export default {
  title: 'Bist du sicher, dass du dein Konto löschen möchtest?',
  description:
    'Das kann nicht rückgängig gemacht werden. Du verlierst den Zugriff auf deine Bestellungen, Treuepunkte und gespeicherten Einstellungen.',
  labels: {
    loading: 'Löschung dein Konto...',
  },
  buttons: {
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
  },
  toasts: {
    success:
      'Dein Konto wurde dauerhaft gelöscht. Du hast keinen Zugriff mehr auf deine Bestellungen, Treuepunkte oder gespeicherten Daten.',
    error:
      'Hoppla, da ist etwas schiefgelaufen. Bitte versuch’s nochmal. Wenn das Problem weiterhin besteht, kontaktiere bitte unseren Support: {{supportEmail}}',
  },
};
